import { CopyButton, useToast } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import styles from './TrackingCode.module.css';

export type TrackingCodeProps = { code: string };

export const TrackingCode = ({ code }: TrackingCodeProps) => {
  const { t } = useTranslation();
  const toast = useToast();
  return (
    <span className={styles['code']}>
      <bdi dir="ltr" className={styles['text']}>
        {code}
      </bdi>
      <CopyButton
        text={code}
        label={t('common.copyBarcode', { code })}
        copiedLabel={t('common.barcodeCopied')}
        onCopyFailed={() => {
          toast.notify({ message: t('common.copyFailed'), tone: 'danger' });
        }}
      />
    </span>
  );
};
